// extracted by mini-css-extract-plugin
module.exports = {"slider_wrap":"styles_slider_wrap__3MRPd","badge":"styles_badge__3YNss","dotClass":"styles_dotClass__1jnaX","dotClassWhite":"styles_dotClassWhite__1uZgA"};